// This is used for polymorphic json requests to the backend image-category/modify api.
export enum ImageCategoryModifyType {
  RenameCategory = 'rename',
  DeleteCategory = 'delete',
  MoveTags = 'moveTags'
}
